import * as React from 'react';
import { FeedItem, FeedEntryType, FeedResource } from '../feed';
import FeedEntrySummary from './FeedEntrySummary';
import { Text, TextArea, Select, MultiSelect, Image } from './forms';

export interface FeedEntryProps {
  index: number;
  entry: FeedItem;
  editing?: boolean;
  onChange: Function;
  onDelete: Function;
  onMoveDown: Function;
  onMoveUp: Function;
}

export interface FeedEntryState {
  editing: boolean;
  entry: FeedItem;
}

export class FeedEntry extends React.Component<FeedEntryProps, FeedEntryState> {
  constructor(props: FeedEntryProps) {
    super(props);

    this.state = {
      editing: props.editing || false,
      entry: props.entry,
    };
  }

  componentWillReceiveProps(newProps: FeedEntryProps) {
    this.setState({
      editing: false,
      entry: newProps.entry,
    });
  }

  onValueChange = (key: string, value: any) => {
    this.setState({
      entry: Object.assign({}, this.state.entry, {
        [key]: value,
      }),
    });
  }

  toggleEditing = () => {
    this.setState({
      editing: !this.state.editing,
    });
  }

  moveEntryUp = () => {
    this.props.onMoveUp(this.props.index, this.props.entry);
  }

  moveEntryDown = () => {
    this.props.onMoveDown(this.props.index, this.props.entry);
  }

  confirmChanges = () => {
    const { onChange, index } = this.props;

    this.setState({ editing: false }, () => onChange(index, this.state.entry));
  }

  deleteItem = () => {
    const { onDelete, index } = this.props;

    this.setState({ editing: false }, () => onDelete(index, this.state.entry));
  }

  get resourceForm() {
    const { entry } = this.state;
    const item = entry as any;

    switch (entry.type as FeedEntryType) {
      case FeedEntryType.Feature:
        return (
          <div key={item.type}>
            <Text
              label="Resource ID"
              field={['resource_id']}
              id="resource_id"
              defaultValue={item.resource_id}
              onValueChange={this.onValueChange}
            />
          </div>
        );
      case FeedEntryType.Collection:
        return (
          <div key={entry.type}>
            <MultiSelect
              label="Resource IDs"
              field={['resource_ids']}
              id="resource_ids"
              defaultValue={item.resource_ids}
              onValueChange={this.onValueChange}
            />
          </div>
        );
      case FeedEntryType.DynamicCollection:
        return (
          <div key={entry.type}>
            <TextArea
              label="Search Query (JSON)"
              field={['resource_query']}
              id="resource_query"
              defaultValue={JSON.stringify(item.resource_query)}
              onValueChange={(key: string, value: string) => {
                this.onValueChange(key, JSON.parse(value));
              }}
              tooltip={`Request URL: /search/${entry.resource_type.toLowerCase()}`}
            />
          </div>
        );
      default:
        return null;
    }
  }

  get form() {
    const { entry } = this.state;

    return (
      <div className="flex-ns flex-column">
        <div className="flex-ns items-center">
          <div className="w-100 w-50-ns pr3 w-50">
            <Select
              label="Cell Type"
              field={['type']}
              id="type"
              defaultValue={entry.type}
              onValueChange={this.onValueChange}
              options={[
                FeedEntryType.Feature,
                FeedEntryType.Collection,
                FeedEntryType.DynamicCollection,
              ].map(val => ({ label: val, value: val }))}
            />
            <hr className="b--white-10 bt bw1 bg-transparent" />
            <Text
              label="Title"
              field={['name']}
              id="name"
              defaultValue={entry.name}
              onValueChange={this.onValueChange}
            />
            <Text
              label="Subtitle"
              field={['description_text']}
              id="description_text"
              defaultValue={entry.description_text}
              onValueChange={this.onValueChange}
            />
            <Text
              label="Public URL"
              field={['public_url']}
              id="public_url"
              defaultValue={entry.public_url}
              onValueChange={this.onValueChange}
            />
            <Image
              label="Header Image"
              field={['image']}
              id="image"
              defaultValue={entry.image_url}
              onValueChange={this.onValueChange}
            />
          </div>
          <div className="w-100 w-50-ns pr3">
            <Select
              label="Resource Type"
              field={['resource_type']}
              id="resource_type"
              defaultValue={entry.resource_type}
              onValueChange={this.onValueChange}
              options={[
                FeedResource.Category,
                FeedResource.Company,
                FeedResource.Guide,
                FeedResource.Product,
              ].map(val => ({ label: val, value: val }))}
            />
            {this.resourceForm}
          </div>
        </div>
        {this.actions}
      </div>
    );
  }

  get actions() {
    return (
      <div className="flex pa3 justify-center">
        <button
          type="button"
          className="ma4 tc red b db link bg-transparent bw0 pointer"
          onClick={this.deleteItem}
        >
          Delete
        </button>
        <button
          type="button"
          className="ma4 tc gold b db link bg-transparent bw0 pointer"
          onClick={this.confirmChanges}
        >
          Done
        </button>
      </div>
    );
  }

  render() {
    return (
      <div className="bb bw1 b--white-10 pv3">
        <FeedEntrySummary
          onEdit={this.toggleEditing}
          onMoveUp={this.moveEntryUp}
          onMoveDown={this.moveEntryDown}
          entry={this.state.entry}
        />
        {this.state.editing && this.form}
      </div>
    );
  }
}

export default FeedEntry;
